module.exports = "<div\r\n  id=\"bws-aem-viewer\"\r\n  ng-attr-data-aem-host=\"{{restHost}}\"\r\n  ng-attr-data-aem-folder=\"{{folder}}\"\r\n  ng-attr-data-aem-project=\"{{project}}\"\r\n  ng-attr-data-rest-host=\"{{dataHost}}\"\r\n  ng-attr-data-aem-is-partial=\"{{partial}}\"\r\n></div>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/aem/aem-portal-template.html
 ** module id = 886
 ** module chunks = 1
 **/